import React from 'react';
// @ts-ignore
import {Route, Switch} from 'react-router-dom';
import HomeComponent from "../home/HomeComponent";
import Constants from "../../data/Constants";
import BpsComponent from "../../components/bpsComponents/BpsComponent";
import BpsMarketComponent from "../../components/bpsComponents/BpsMarketComponent";
import BpsRegionsComponent from "../../components/bpsComponents/bpsRegionsComponent";


const BpsContainer = () => (
    <HomeComponent>
        <Switch>
            <Route exact path={Constants.routes.bps} component={HomeBps}/>
            <Route exact path={Constants.routes.bpsRegions} component={BpsRegions}/>
            <Route exact path={Constants.routes.bpsMarket} component={BpsMarket}/>
        </Switch>
    </HomeComponent>
);

export default BpsContainer;

export const HomeBps: React.FC = () => {
    return (
        <BpsComponent />
    )
};

export const BpsRegions: React.FC = () => {
    return (
        <BpsRegionsComponent />
    )
};

export const BpsMarket: React.FC = () => {
    return (
        <BpsMarketComponent />
    )
};
